var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4633A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3337 26.6667V30.6667C37.3337 32.88 35.547 34.6667 33.3337 34.6667H32.0003C32.0003 33.2 30.8003 32 29.3337 32C27.867 32 26.667 33.2 26.667 34.6667H21.3337C21.3337 33.2 20.1337 32 18.667 32C17.2003 32 16.0003 33.2 16.0003 34.6667H14.667C12.4537 34.6667 10.667 32.88 10.667 30.6667V26.6667H25.3337C26.8003 26.6667 28.0003 25.4667 28.0003 24V14.6667H30.4537C31.4137 14.6667 32.2937 15.1867 32.7737 16.0134L35.0536 20H33.3337C32.6003 20 32.0003 20.6 32.0003 21.3334V25.3334C32.0003 26.0667 32.6003 26.6667 33.3337 26.6667H37.3337Z",
    fill: "#F4633A",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 37.3333C20.1394 37.3333 21.3333 36.1394 21.3333 34.6667C21.3333 33.1939 20.1394 32 18.6667 32C17.1939 32 16 33.1939 16 34.6667C16 36.1394 17.1939 37.3333 18.6667 37.3333Z",
    fill: "#F4633A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 37.3333C30.8064 37.3333 32.0003 36.1394 32.0003 34.6667C32.0003 33.1939 30.8064 32 29.3337 32C27.8609 32 26.667 33.1939 26.667 34.6667C26.667 36.1394 27.8609 37.3333 29.3337 37.3333Z",
    fill: "#F4633A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 24.7067V26.6667H33.3333C32.6 26.6667 32 26.0667 32 25.3333V21.3333C32 20.6 32.6 20 33.3333 20H35.0533L36.9867 23.3866C37.2133 23.7866 37.3333 24.24 37.3333 24.7067Z",
    fill: "#F4633A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 10.6667H15.9993C13.3993 10.6667 11.2394 12.5334 10.7727 15H17.3327C17.8793 15 18.3327 15.4534 18.3327 16C18.3327 16.5467 17.8793 17 17.3327 17H10.666V19H14.666C15.2127 19 15.666 19.4534 15.666 20C15.666 20.5467 15.2127 21 14.666 21H10.666V23H11.9993C12.546 23 12.9993 23.4534 12.9993 24C12.9993 24.5467 12.546 25 11.9993 25H10.666V26.6667H25.3327C26.7993 26.6667 27.9993 25.4667 27.9993 24V12C27.9993 11.2667 27.3993 10.6667 26.666 10.6667Z",
    fill: "#F4633A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.773 15H9.33301C8.78634 15 8.33301 15.4533 8.33301 16C8.33301 16.5467 8.78634 17 9.33301 17H10.6663V16C10.6663 15.6533 10.7064 15.32 10.773 15Z",
    fill: "#F4633A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 19C8.78634 19 8.33301 19.4533 8.33301 20C8.33301 20.5467 8.78634 21 9.33301 21H10.6663V19H9.33301Z",
    fill: "#F4633A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 23C8.78634 23 8.33301 23.4533 8.33301 24C8.33301 24.5467 8.78634 25 9.33301 25H10.6663V23H9.33301Z",
    fill: "#F4633A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeShipping);
export default __webpack_public_path__ + "static/media/free-shipping.c96ea05c1ff047f527dc8e2821485d94.svg";
export { ForwardRef as ReactComponent };